const getters = {
    allBoards: (state) => state.boardList.data,
    allBoardsPending: (state) => state.boardList.status.pending,
};

export default getters;
